import IconeTarefaNotificacao from '@/modules/system/notificacoes/IconeTarefaNotificacao';
import ModalTarefaNotificacao, {
  EstadoTarefaModal,
} from '@/modules/system/notificacoes/ModalTarefaNotificacao';

import ModalExcluir from '@/shared/components/modals/ModalExcluir';

import Links from '@/shared/constants/navegacao';

import Loading from '@/shared/components/Carregando';

import { ApiReturn } from '@/modules/api.service';

import { DataEHoraAmigavel } from '@/shared/utils/datas';
import { DeleteNotificaco, DeleteTodasNotificacoes, GetNotificacoes, CriarNotificacaoTarefa, AtenderNotificacaoTarefa, } from '@/modules/system/notificacoes/notificacoes.service';
import {
  notificacaoDetalhesExibicao,
  notificacaoTituloExibicao,
} from '@/modules/system/notificacoes/notificacao-display.utils';
import { Fragment, useMemo, useEffect, useState } from 'react';

import { Link } from 'react-router-dom';

import { NotificacaoDto } from '@/api.types';

import { toast } from 'react-toastify';



const OPCOES_TIPO = [

  { value: '', label: 'Todos os tipos' },

  { value: 'ACAO', label: 'Ação' },

  { value: 'LOTACAO', label: 'Lotação' },

  { value: 'PESSOA', label: 'Pessoa' },

] as const;



type ModalTarefaState = {
  notificacaoId: string;
  tarefaId?: string;
  titulo: string;
  estado: EstadoTarefaModal;
  editadoPorNome?: string;
  editadoEm?: string;
};

function getEstadoTarefa(item: NotificacaoDto): EstadoTarefaModal {
  if (!item.tarefa?.id) {
    return 'sem_tarefa';
  }
  if (item.tarefa.atendida) {
    return 'atendida';
  }
  return 'em_atendimento';
}



export default function NotificacoesIndexPage() {

  const [loading, setLoading] = useState<boolean>(true);

  const [reload, setReload] = useState<boolean>(false);

  const [modalExcluirTodas, setModalExcluirTodas] = useState(false);

  const [modalTarefa, setModalTarefa] = useState<ModalTarefaState | null>(null);
  const [processandoTarefa, setProcessandoTarefa] = useState(false);

  const [filtroTipo, setFiltroTipo] = useState<string>('');

  const [registros, setRegistros] = useState<ApiReturn<NotificacaoDto>>({

    objects: [],

    count: 0,

  });



  const registrosFiltrados = useMemo(() => {

    if (!filtroTipo) return registros.objects;

    return registros.objects.filter((item) => item.tipo === filtroTipo);

  }, [registros.objects, filtroTipo]);



  useEffect(() => {

    GetNotificacoes(false)

      .then((result) => {

        setRegistros(result);

        setLoading(false);

        setReload(false);

      })

      .catch((res) => {

        toast.error((res as string) + '');

      });

  }, [reload]);



  function handleClick(id: string) {

    setReload(true);

    DeleteNotificaco(id)

      .then((res) => {

        toast.success(res + '');

      })

      .catch((res) => {

        toast.error((res as string) + '');

      });

  }



  function handleExcluirTodas(e: React.MouseEvent<HTMLButtonElement>) {

    e.preventDefault();

    setModalExcluirTodas(false);

    DeleteTodasNotificacoes()

      .then((res) => {

        toast.success(res + '');

        setReload(true);

      })

      .catch((res) => {

        toast.error((res as string) + '');

      });

  }



  function abrirModalTarefa(item: NotificacaoDto) {
    const estado = getEstadoTarefa(item);
    setModalTarefa({
      notificacaoId: item.id,
      tarefaId: item.tarefa?.id,
      titulo: item.titulo ?? 'Notificação',
      estado,
      editadoPorNome: item.tarefa?.editadoPorNome,
      editadoEm: item.tarefa?.editadoEm,
    });
  }

  function handleCriarTarefa(concluida: boolean) {
    if (!modalTarefa || modalTarefa.estado !== 'sem_tarefa') {
      return;
    }
    setProcessandoTarefa(true);
    CriarNotificacaoTarefa(modalTarefa.notificacaoId, concluida)
      .then((res: string) => {
        toast.success(res + '');
        setModalTarefa(null);
        setReload(true);
      })
      .catch((res: unknown) => {
        toast.error((res as string) + '');
      })
      .finally(() => {
        setProcessandoTarefa(false);
      });
  }

  function handleAtender() {
    if (!modalTarefa?.tarefaId || modalTarefa.estado !== 'em_atendimento') {
      return;
    }
    setProcessandoTarefa(true);
    AtenderNotificacaoTarefa(modalTarefa.tarefaId)
      .then((res: string) => {
        toast.success(res + '');
        setModalTarefa(null);
        setReload(true);
      })
      .catch((res: unknown) => {
        toast.error((res as string) + '');
      })
      .finally(() => {
        setProcessandoTarefa(false);
      });
  }



  const getLinkParaNotificacao = (notificacao: NotificacaoDto): string | null => {

    if (!notificacao.idregistro) {

      return null;

    }



    switch (notificacao.tipo) {

      case 'ACAO':

        return Links.Acoes_Editar + '/' + notificacao.idregistro;

      case 'LOTACAO':

        return Links.Vinculos_Editar + '/' + notificacao.idregistro;

      case 'PESSOA':

        return Links.Pessoa_Editar + '/' + notificacao.idregistro;

      default:

        return Links.Acoes_Editar + '/' + notificacao.idregistro;

    }

  };



  const renderBotaoTarefa = (item: NotificacaoDto) => {
    const estado = getEstadoTarefa(item);

    return (
      <button
        type="button"
        className="btn btn-sm btn-link p-1 border-0 text-decoration-none d-inline-flex align-items-center justify-content-center"
        title={
          estado === 'sem_tarefa'
            ? 'Criar tarefa de atendimento'
            : estado === 'em_atendimento'
              ? 'Tarefa em andamento'
              : 'Tarefa concluída'
        }
        onClick={() => abrirModalTarefa(item)}
      >
        <IconeTarefaNotificacao estado={estado} />
      </button>
    );
  };



  return (

    <Fragment>

      <div className="row">

        <div className="col-md-8">
          <h3>Notificações</h3>
          <span className="blockquote-footer pb-4 text-end">

            Suas notificações ({filtroTipo ? registrosFiltrados.length : registros.count}).

          </span>

        </div>
        <div className="col-md-4 text-end">
          {!loading && registros.count > 0 && (

            <button

              type="button"

              className="btn btn-outline-danger btn-sm"

              onClick={() => setModalExcluirTodas(true)}

            >

              Excluir todas

            </button>

          )}

        </div>

        <div className="col-12 mb-3">

          <label htmlFor="filtro-tipo" className="form-label me-2">Filtrar por tipo:</label>

          <select

            id="filtro-tipo"

            className="form-select form-select-sm w-auto d-inline-block"

            value={filtroTipo}

            onChange={(e) => setFiltroTipo(e.target.value)}

          >

            {OPCOES_TIPO.map((op) => (

              <option key={op.value || 'todos'} value={op.value}>

                {op.label}

              </option>

            ))}

          </select>

        </div>

        <hr className="pb-4" />



        {!loading && (

          <div className="tabela">

            <table className="table table-sm table-striped table-hover">

              <thead>

                <tr className="justify-content-center">

                  <th scope="col">Data</th>

                  <th scope="col">Título</th>

                  <th scope="col">Detalhes</th>

                  <th scope="col">Tarefa</th>

                  <th scope="col">Ações</th>

                </tr>

              </thead>

              <tbody className="table-group-divider">

                {registros &&

                  typeof registros !== 'undefined' &&

                  registros !== null &&
                  registrosFiltrados.map((item, index) => {
                    const titulo = notificacaoTituloExibicao(item.titulo);
                    const detalhes = notificacaoDetalhesExibicao(item.detalhes);

                    return (
                      <tr key={index} title={`${item.idregistro}`}>

                        <td>{DataEHoraAmigavel(item.criadoEm)}</td>

                        <td>

                          {(() => {

                            const link = getLinkParaNotificacao(item);

                            return link ? (

                              <Link

                                to={link}

                                target="_blank"

                              >
                                {titulo}
                              </Link>

                            ) : (
                              <span>{titulo}</span>
                            );

                          })()}

                        </td>
                        <td>{detalhes ?? '—'}</td>
                        <td className="text-center">{renderBotaoTarefa(item)}</td>
                        <td className="justify-content-center">

                          <button

                            type="button"

                            className="btn btn-outline-danger btn-sm"

                            title="Excluir Notificação"

                            onClick={() => handleClick(item.id)}

                          >

                            Excluir

                          </button>

                        </td>

                      </tr>
                    );
                  })}
              </tbody>

            </table>

          </div>

        )}

        {loading && <Loading />}

      </div>



      <ModalExcluir

        show={modalExcluirTodas}

        handleExcluir={handleExcluirTodas}

        handleHide={() => setModalExcluirTodas(false)}

        mensagemPersonalizada="Tem certeza que deseja excluir todas as notificações? Esta ação não pode ser desfeita."

      />



      {modalTarefa && (
        <ModalTarefaNotificacao
          show={!!modalTarefa}
          titulo={modalTarefa.titulo}
          estado={modalTarefa.estado}
          editadoPorNome={modalTarefa.editadoPorNome}
          editadoEm={modalTarefa.editadoEm}
          onHide={() => setModalTarefa(null)}
          onCriarTarefa={handleCriarTarefa}
          onAtender={handleAtender}
          loading={processandoTarefa}
        />
      )}

    </Fragment>

  );

}

